var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "profile-field__title",
          class: {
            "profile-field__title--required": _vm.field.required,
          },
        },
        [_vm._v(" Документы ")]
      ),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "snils" },
          [
            _c("c-input", {
              attrs: {
                label: "СНИЛС",
                clearable: true,
                placeholder: "___-___-___-__",
                mask: "###-###-###-##",
                invalid: _vm.error && (_vm.error.common || _vm.error.snils),
                error: _vm.error && _vm.error.snils,
              },
              model: {
                value: _vm.snils,
                callback: function ($$v) {
                  _vm.snils = $$v
                },
                expression: "snils",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "inn" },
          [
            _c("c-input", {
              attrs: {
                "floating-label": "ИНН",
                type: "price-number",
                "max-length": 30,
                "fractional-length": 0,
                clearable: true,
                invalid: _vm.error && (_vm.error.common || _vm.error.inn),
                error: _vm.error && _vm.error.inn,
              },
              model: {
                value: _vm.inn,
                callback: function ($$v) {
                  _vm.inn = $$v
                },
                expression: "inn",
              },
            }),
          ],
          1
        ),
      ]),
      _vm.error && _vm.error.common
        ? _c("error-feedback", {
            attrs: { text: _vm.error && _vm.error.common },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }